/*
 * This illustrates how to create a widget that makes use of a number of different field definition types.
 */

import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

// this is used to help ensure that the names match between props.fields and definition.fieldDefinitions[].name
const enum fields {
    className = "className",
    componentContent = "componentContent",
}

// these are the props for the component, aka the predefined arguments defined for the class
interface OwnProps extends WidgetProps {
    fields: {
        [fields.className]: string;
        [fields.componentContent]: string;
    };
    extendedStyles?: ComponentStyles;
    history: History;
}

export interface ComponentStyles {
    componentWrapper?: InjectableCss;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const pageLink = "/";
    return { pageLink };
};

const mapDispatchToProps = {};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const StyledRichTextComponent: React.FunctionComponent<Props> = ({
    // external props like the cardLink for example, need to be mapped to the internal state via mapStateToProps
    // cardLink,
    fields,
    history,
    ...otherProps
}: Props) => {
    return (
        <div>
            <div className={fields.className}>{parse(fields.componentContent, parserOptions)}</div>
        </div>
    );
};

const definition: WidgetDefinition = {
    group: "Common",
    fieldDefinitions: [
        {
            name: fields.className,
            displayName: "Class Name",
            editorTemplate: "TextField", // this references the ContentItemFields .tsx files
            defaultValue: "",
            fieldType: "General",
            tooltip: "The name of the content component's class.",
            placeholder: "Enter a unqiue class name",
            isRequired: true,
        },
        {
            name: fields.componentContent,
            displayName: "Component content",
            editorTemplate: "RichTextField",
            defaultValue: "",
            fieldType: "General",
            placeholder: "Enter rich text content",
            isRequired: false,
        },
    ],
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(StyledRichTextComponent)),
    definition,
};

export default widgetModule;
